
const BREAKPOINT_XXL = 'xxl';
const BREAKPOINT_XL = 'xl';
const BREAKPOINT_LG = 'lg';
const BREAKPOINT_MD = 'md';
const BREAKPOINT_SM = 'sm';
const BREAKPOINT_XS = 'xs';

function getScreenBreakpoint(screenWidth) {
  if (screenWidth >= 1400) {
    return BREAKPOINT_XXL;
  } else if (screenWidth >= 1200) {
    return BREAKPOINT_XL;
  } else if (screenWidth >= 992) {
    return BREAKPOINT_LG;
  } else if (screenWidth >= 768) {
    return BREAKPOINT_MD;
  } else if (screenWidth >= 576) {
    return BREAKPOINT_SM;
  } else {
    return BREAKPOINT_XS;
  }
}

function getContainerMaxWidth(breakpoint) {
  switch (breakpoint) {
    case BREAKPOINT_XXL:
      return 1320;
    case BREAKPOINT_XL:
      return 1140;
    case BREAKPOINT_LG:
      return 960;
    case BREAKPOINT_MD:
      return 720;
    case BREAKPOINT_SM:
      return 540;
    case BREAKPOINT_XS:
      return 540;
    default:
      return 0;
  }
}

function getContainerWidth(screenWidth) {
  const breakpoint = getScreenBreakpoint(screenWidth);
  const maxWidth = getContainerMaxWidth(breakpoint);
  return Math.min(screenWidth, maxWidth);
}

export { getScreenBreakpoint, getContainerMaxWidth, getContainerWidth };
